/*
 * UserCard Messages
 *
 * This contains all the strings for the UserCard component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  // Score rating abbr
  score: 'S',
  // Reward rating abbr
  reward: 'R',
});
